import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Pages
import { HomeComponent } from './components/pages/home/home.component';
import { AboutUsComponent } from './components/pages/about-us/about-us.component';
import { ServicesComponent } from './components/pages/services/services.component';
import { ServiceDetailsComponent } from './components/pages/service-details/service-details.component';
import { OurProjectsComponent } from './components/pages/our-projects/our-projects.component';
import { ProjectDetailsComponent } from './components/pages/project-details/project-details.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { CareerDetailsComponent } from './components/pages/career-details/career-details.component';
import { LatesNewsComponent } from './components/pages/lates-news/lates-news.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ContactUsComponent } from './components/pages/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/pages/terms-of-service/terms-of-service.component';
// Our Services
import { WebsiteDevelopmentComponent } from './components/services/website-development/website-development.component';
import { MobileDevelopmentComponent } from './components/services/mobile-development/mobile-development.component';
import { AppDevelopmentComponent } from './components/services/app-development/app-development.component';
import { UxUiDesignComponent } from './components/services/ux-ui-design/ux-ui-design.component';
import { IosDevelopmentComponent } from './components/services/ios-development/ios-development.component';
import { AndroidDevelopmentComponent } from './components/services/android-development/android-development.component';
import { SoftwareDevelopmentComponent } from './components/services/software-development/software-development.component';
import { MaintenanceAndUpdatesComponent } from './components/services/maintenance-and-updates/maintenance-and-updates.component';
import { SeoServicesComponent } from './components/services/seo-services/seo-services.component';
import { AnalysisComponent } from './components/services/analysis/analysis.component';
import { TestingAndReviewComponent } from './components/services/testing-and-review/testing-and-review.component';
import { DeploymentComponent } from './components/services/deployment/deployment.component';
import { AiAssistedIntegrationsComponent } from './components/services/ai-assisted-integrations/ai-assisted-integrations.component';
import { LogoDesignComponent } from './components/services/logo-design/logo-design.component';
// Error Page
import { ErrorComponent } from './components/pages/error/error.component';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'about-us', component: AboutUsComponent },
    { path: 'services', component: ServicesComponent },
    { path: 'service-details', component: ServiceDetailsComponent },
    { path: 'our-projects', component: OurProjectsComponent },
    { path: 'project-details', component: ProjectDetailsComponent },
    { path: 'careers', component: CareersComponent },
    { path: 'careers/:slug', component: CareerDetailsComponent },
    { path: 'latest-news', component: LatesNewsComponent },
    { path: 'latest-news/:slug', component: BlogDetailsComponent },
    { path: 'contact', component: ContactUsComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: 'terms-and-conditions', component: TermsOfServiceComponent },

    { path: 'website-development', component: WebsiteDevelopmentComponent },
    { path: 'mobile-development', component: MobileDevelopmentComponent },
    { path: 'app-development', component: AppDevelopmentComponent },
    { path: 'ai-assisted-integrations', component: AiAssistedIntegrationsComponent },
    { path: 'design', component: UxUiDesignComponent },
    { path: 'logo-design', component: LogoDesignComponent },
    { path: 'ios-development', component: IosDevelopmentComponent },
    { path: 'android-development', component: AndroidDevelopmentComponent },
    { path: 'software-development', component: SoftwareDevelopmentComponent },
    { path: 'maintenance-and-updates', component: MaintenanceAndUpdatesComponent },
    { path: 'seo-services', component: SeoServicesComponent },
    { path: 'planning-and-requirement-gathering', component: AnalysisComponent },
    { path: 'testing-and-review', component: TestingAndReviewComponent },
    { path: 'deployment', component: DeploymentComponent },

    { path: '**', component: ErrorComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
